module.exports = __webpack_public_path__ + "static/img/Home67@2x.c470979.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home67@2x.png
// module id = EvCy
// module chunks = 1